// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { changeCustomerBillToSelectorStyles } from "@werner/Overrides/Widgets/ChangeCustomer/ChangeCustomerBillToSelector";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

changeCustomerBillToSelectorStyles.wrapper = {
    css: css`
        position: relative;
        width: 100%;
    `,
};

changeCustomerBillToSelectorStyles.clearIconStyles = {
    size: 14,
    css: css`
        position: absolute;
        top: 28px;
        right: 50px;
        &:hover {
            color: ${color("primary")};
        }
    `,
};

changeCustomerBillToSelectorStyles.billToSelectorDynamicDropdown = {
    cssOverrides: {
        selectedText: css`
            &&&&&& {
                padding-right: 50px;
            }
        `,
    },
};
